export function normalizePhone(raw: string): string {
  return raw.replace(/[^\d]/g, "");
}

export function isValidPhone(raw: string): boolean {
  const digits = normalizePhone(raw);
  return digits.length >= 8 && digits.length <= 15;
}

export function isValidName(raw: string): boolean {
  return raw.trim().length >= 2;
}

export function isValidProductCount(n: number, min: number, max: number): boolean {
  return Number.isInteger(n) && n >= min && n <= max;
}

export function isValidPhotosPerProduct(n: number, min: number, max: number): boolean {
  return Number.isInteger(n) && n >= min && n <= max;
}
